export const faqs = [
  {
    id: 1,
    question: "كيف أحصل على خدمة الونش؟",
    answer:
      "للحصول على خدمة الونش، اتصل بنا على رقمنا الموحد أو أرسل رسالة واتساب. سنطلب منك موقعك الحالي ونوع السيارة، وسيصل فريقنا إليك خلال 30 دقيقة أو أقل في معظم الحالات.",
  },
  {
    id: 2,
    question: "كم من الوقت يستغرق وصول الونش؟",
    answer:
      "عادةً نصل خلال 20-30 دقيقة داخل المدن الكبرى، و30-45 دقيقة في الضواحي والمدن الجديدة، وساعة إلى ساعتين في المناطق النائية. وقت الاستجابة يعتمد على موقعك الحالي وحركة المرور.",
  },
  //   {
  //     id: 3,
  //     question: "لماذا سحبت سيارتي؟",
  //     answer:
  //       "قد يتم سحب السيارة للعديد من الأسباب: الوقوف في مكان ممنوع، انتهاء رخصة السيارة، وجود مخالفات مرورية غير مدفوعة، أو بناءً على طلب السلطات المختصة. يمكنك التواصل معنا لمعرفة تفاصيل سحب سيارتك.",
  //   },
  {
    id: 4,
    question: "ما هي تكلفة خدمة الونش؟",
    answer:
      "التكلفة تعتمد على عدة عوامل: المسافة المقطوعة، نوع السيارة، والوقت (النهار أو الليل). نحن نقدم أسعاراً تنافسية وشفافة، وسنخبرك بالتكلفة الكاملة قبل بدء الخدمة بدون رسوم خفية.",
  },
  {
    id: 5,
    question: "هل خدمتكم متاحة 24 ساعة؟",
    answer:
      "نعم، خدماتنا متاحة على مدار 24 ساعة طوال أيام الأسبوع، بما في ذلك أيام العطل والإجازات الرسمية. نحن دائماً جاهزون لمساعدتك في أي وقت تحتاج فيه لخدمة إنقاذ أو ونش.",
  },
  //   {
  //     id: 6,
  //     question: "هل تغطون جميع محافظات مصر؟",
  //     answer:
  //       "نعم، نقدم خدماتنا في جميع محافظات مصر من الإسكندرية إلى أسوان ومن القاهرة إلى البحر الأحمر. لدينا شبكة واسعة من الونشات الموزعة استراتيجياً في جميع أنحاء الجمهورية.",
  //   },
  {
    id: 7,
    question: "ماذا أفعل عند تعطل سيارتي على الطريق السريع؟",
    answer:
      "أولاً، حرك سيارتك إلى جانب الطريق بأمان إن أمكن. شغل الإشارات التحذيرية وضع المثلث العاكس. ابتعد عن الطريق إلى مكان آمن، ثم اتصل بنا على الفور. لا تحاول الإصلاح على الطريق السريع.",
  },
  //   {
  //     id: 8,
  //     question: "هل سيارتي مؤمنة أثناء النقل؟",
  //     answer:
  //       "نعم، جميع السيارات المنقولة مؤمنة بالكامل. نحن نستخدم أفضل المعدات والتقنيات الآمنة للحفاظ على سيارتك. في الحالات النادرة جداً لحدوث أي ضرر، تأميننا الشامل يغطي التكاليف.",
  //   },
];

export default faqs;
